const { default: specialPanelFix } = require("./components/specialPanel");
const { default: initTopSpacer } = require("./components/topSpacer");
const { default: initYMap } = require("./components/ymap");

window.addEventListener("load", function () {
    initTopSpacer();
    personalDataProcessingWidget();
    appointmentAgreement();
    buildMunicipalities();
    servicesFilter();
    searchForm();
    tabsInit();
    tabsPaginations();

    specialPanelFix();
    initYMap();
});

/* LOAD FILES */

var _loadedFiles = [];

function loadFiles(url, callback) {
    var debug = false; // ОБРАТИТЬ ВНИМАНИЕ

    callback = callback || function () {};

    switch (true) {
        case Array.isArray(url):
            var size = url.length,
                c = 0;
            for (var i in url) {
                if (debug) url[i] += "?rand=" + Math.random();
                includeFilesItem(url[i], function () {
                    // console.log(url[i], 'загружен');
                    c++;
                    if (c >= size) {
                        callback();
                    }
                });
            }
            break;
        default:
            if (debug) url += "?rand=" + Math.random();
            includeFilesItem(url, callback);
            break;
    }
}

function includeFilesItem(url, callback) {
    // Adding the script tag to the head as suggested before
    var head = document.getElementsByTagName("head")[0],
        src = url,
        scripts;
    if (src.indexOf("//") == -1) {
        // Внимание!
        src =
            document.location.protocol +
            "//" +
            document.location.hostname +
            src;
    }

    var type = url.split("?")[0].split(".").pop();

    switch (type) {
        case "css":
            scripts = document.getElementsByTagName("link");
            for (var i in scripts) {
                if (
                    scripts[i].href &&
                    scripts[i].href.split("?")[0] == src.split("?")[0]
                ) {
                    if (callback) callback();
                    return true;
                }
            }
            var script = document.createElement("link");
            script.rel = "stylesheet";
            script.type = "text/css";
            script.href = url;
            break;
        default:
            scripts = document.getElementsByTagName("script");
            for (var i in scripts) {
                if (
                    scripts[i].src &&
                    scripts[i].src.split("?")[0] == src.split("?")[0]
                ) {
                    // скрипт на страничке есть. но загрузился ли он?
                    if (_loadedFiles.indexOf(scripts[i].src) > -1 && callback)
                        callback();
                    // if (callback) callback();
                    return true;
                }
            }
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = url;
            break;
    }

    // Then bind the event to the callback function.
    // There are several events for cross browser compatibility.
    script.onreadystatechange = onLoad;
    script.onload = onLoad;

    // Fire the loading
    head.appendChild(script);

    function onLoad() {
        _loadedFiles.push(this.src);
        callback();
    }
}

/* PersonalDataProcessingWidget */
function personalDataProcessingWidget() {
    const widget = $(".personal-data-processing-widget");
    const cookieName = widget.data("cookie-name");

    if (!cookieName) {
        return false;
    }

    loadFiles("/site-assets/js/jquery/jquery.cookie.js", function () {
        const value = $.cookie(cookieName);
        if (!value) {
            widget.show();
        }

        const acceptanceButton = widget.find(".widget-button button");
        const date = new Date();

        acceptanceButton.on("click", () => {
            $.cookie(cookieName, true, {
                expires: date.getDate() + 30,
                path: "/",
            });

            widget.hide();
        });
    });
}

/* Appointment */

function appointmentAgreement() {
    const checkbox = $(".agreement-check-item");
    const popup = $(".agreement-popup");
    const options = $(".appointment-options .options-item");

    if (checkbox.length) {
        checkbox.on("click", "label button", function () {
            popup.addClass("open");
        });

        popup.on("click", ".popup-close-button", function () {
            popup.removeClass("open");
        });

        options.on("click", function (e) {
            if (!$("input", checkbox).is(":checked")) {
                e.preventDefault();
                checkbox.addClass("error");
            }
        });

        checkbox.on("change", "input", function () {
            checkbox.removeClass("error");
        });
    }
}

/* Offices Municipalities */

function buildMunicipalities() {
    if (!$(".widget-municipalities-data").text()) {
        return null;
    }

    let municipalitiesContainer = $(".municipalities-container"),
        containerTabs = $(municipalitiesContainer).find(".tabs"),
        containerTabsData = $(municipalitiesContainer).find(".tabs-data"),
        municipalitiesData = JSON.parse(
            $(".widget-municipalities-data").text()
        ),
        allOffices = JSON.parse(municipalitiesData.allOffices || []);

    if (
        !municipalitiesData ||
        !municipalitiesData.municipalities ||
        !(municipalitiesData.municipalities instanceof Array)
    ) {
        return null;
    }

    let allOfficesDataContainer = $(containerTabsData).find("#data-0");

    $(allOfficesDataContainer).fadeOut(0);

    if (eachOffices(allOffices, allOfficesDataContainer)) {
        $(allOfficesDataContainer).fadeIn(300);
        if (eachMunicipalities()) {
            $(containerTabs).find(".tab-item").fadeIn(300);
        }
    }

    function eachOffices(offices, container) {
        $.each(offices, function (i, office) {
            let item =
                '<div data-id="' + office.id +
                '" class="tabs-data-item">' +
                office.city + ', ' + office.street +
                "</div>";
            $(container).append(item);
        });
        return true;
    }

    function eachMunicipalities() {
        $.each(municipalitiesData.municipalities, function (i, municipality) {
            let itemData =
                    '<div id="data-' +
                    municipality.id +
                    '" class="tabs-data-body" data-tab-data-id="' +
                    municipality.id +
                    '" style="display: none;"></div>',
                offices = JSON.parse(municipality.offices || []);
            $(containerTabsData).append(itemData);
            if (offices.length !== 0) {
                eachOffices(offices, $("#data-" + municipality.id));
            }
        });
        return true;
    }

    $(document).on("click", ".tabs .tab-item", function () {
        let thisTab = $(this),
            thisData = $(".municipalities-container .tabs-data").find(
                "#" + $(thisTab).attr("data-tab-id")
            );

        console.log(thisData);
        $(".municipalities-container .tabs .tab-item").removeClass("active");
        $(".municipalities-container .tabs-data .tabs-data-body").hide();
        $(thisTab).addClass("active");
        $(thisData).fadeIn(300);
    });

    $(document).on("click", ".tabs-data .tabs-data-item", function () {
        openMapPlacemark($(this).attr("data-id"));
    });
}

/* Services Filter */

function servicesFilter() {
    const filter = $(".services-categories-filter");
    if (filter.length) {
        filter.on("click", ".category-item .item-button", function () {
            $(this).closest(".category-item").toggleClass("collapse");
        });

        filter.on("click", ".category-check-item input", function () {
            refreshFilter();
        });

        filter.on("click", ".filter-submit", function () {
            refreshFilter();
        });
    }

    function refreshFilter() {
        const filterParams = getCategoriesFilterParams() || {};
        const url = getFilterUrl(filterParams);
        if (url === "") {
            location.href = location.pathname;
        } else {
            location.href = location.pathname + "?" + url;
        }
    }

    function getCategoriesFilterParams() {
        if (!filter.length) {
            return null;
        }

        // решил избавиться от длинных непонятных урлов

        // https://stackoverflow.com/questions/1829519/jquery-to-serialize-only-elements-within-a-div
        let serialized = $(":input", filter).serialize();
        if (!serialized) {
            return null;
        }

        // https://stackoverflow.com/questions/8648892/how-to-convert-url-parameters-to-a-javascript-object
        let params = JSON.parse(
            '{"' +
                decodeURI(serialized)
                    .replace(/"/g, '\\"')
                    .replace(/&/g, '","')
                    .replace(/=/g, '":"') +
                '"}'
        );
        if (!params) {
            return null;
        }

        let result = {};
        for (let key in params) {
            let name = key.split("[")[0];
            if (!result[name]) {
                result[name] = [];
            }
            result[name].push(params[key]);
        }

        return result;
    }

    function getFilterUrl(filterParams) {
        let filterUrl = serializeParams(filterParams) || "",
            sQuery = getSearchQuery() || "";

        if (sQuery === "") {
            return filterUrl;
        } else {
            if (filterUrl === "") {
                return sQuery;
            } else {
                return filterUrl + "&" + sQuery;
            }
        }
    }

    function serializeParams(filterParams) {
        let result = [];
        for (let name in filterParams) {
            result.push(name + "=" + filterParams[name].join(","));
        }

        return result.join("&");
    }
}

function getSearchQuery() {
    let sQuery = new URL(location.href).searchParams.get("squery");
    if (sQuery) {
        return "squery=" + sQuery;
    }
    return "";
}

function searchForm() {
    let searchForm = $(".search-form-js form"),
        sQuery = $(searchForm).find('[name="squery"]'),
        cancelButton = $(searchForm).find(".cancel-button");

    if (searchForm.length === 0 || sQuery.length === 0) {
        return false;
    }

    if (sQuery.val().length > 1) {
        $(cancelButton).fadeIn(300);
    } else {
        $(cancelButton).fadeOut(300);
    }

    searchForm.on("submit", function (e) {
        e.preventDefault();
        submitForm(getSearchUrl(sQuery.val()), null, false, false);
    });

    $(sQuery).on("keyup change", function (e) {
        e.preventDefault();
        if (sQuery.val().length > 1) {
            $(cancelButton).fadeIn(300);
        } else {
            $(cancelButton).fadeOut(300);
        }
    });

    $(cancelButton).on("click", function (e) {
        e.preventDefault();
        sQuery.val("");
        $(cancelButton).fadeOut(300);
    });

    function getSearchUrl(searchString) {
        let url = "",
            filterParams = "",
            urlQuery = document.location.search;

        if (urlQuery !== "") {
            urlQuery = urlQuery.replace("?&", "?");
            urlQuery = urlQuery.substr(1);
            if (urlQuery !== "?" && urlQuery !== "") {
                let params = JSON.parse(
                    '{"' +
                        decodeURI(urlQuery)
                            .replace(/"/g, '\\"')
                            .replace(/&/g, '","')
                            .replace(/=/g, '":"') +
                        '"}'
                );
                if (params) {
                    $.each(params, function (key, val) {
                        if (key !== "squery") {
                            appendToFilterParams(key, val);
                        }
                    });
                }
            }
        }

        function appendToFilterParams(key, val) {
            if (key !== "" || val !== "") {
                if (filterParams === "") {
                    filterParams = "?" + key + "=" + val;
                } else {
                    filterParams = filterParams + "&" + key + "=" + val;
                }
            }
        }

        if (filterParams) {
            url = location.pathname + filterParams + "&squery=" + searchString;
        } else {
            url = location.pathname + "?squery=" + searchString;
        }

        return url;
    }

    function submitForm(url, postData, isAjax, ajaxMethod) {
        if (url === "") {
            return false;
        }

        if (!ajaxMethod) {
            ajaxMethod = "GET";
        }

        if (!isAjax) {
            location.href = url;
        } else {
            // Делаем Ajax запрос
        }
    }
}

// переключение табов
function tabsInit() {
    $(".tabs-item-js").on("click", function (e) {
        $(".tabs-item-js").removeClass("active");
        let currentElement = $(e.currentTarget);
        currentElement.addClass("active");
        $(".tabs--content-js").removeClass("active");
        let idTab = currentElement.data("tab");
        $(`#${idTab}`).addClass("active");
        let url = `${window.location.pathname}${window.location.search}`;

        let currentPage = currentElement.attr("data-current-page"); //получаю номер последней открытой страницы у активного таба

        // если в таб ранее контент уже был загружен, то ajax не отправляем
        if ($(`#${idTab}`).children().length) {
            return false;
        }

        $.ajax({
            url: `${url}&page=${currentPage}`,
            data: {
                type: idTab,
            },
            success: function (responseHtml) {
                $(`#${idTab}`).html($(responseHtml).find(`#${idTab}`).html());
            },
        });
    });
}

// клик по пагинации
function tabsPaginations() {
    $(document).on("click", ".tabs--content-js .pagination a", function (e) {
        e.preventDefault();
        let currentElement = $(e.currentTarget);
        let url = currentElement.attr("href");
        let idTab = $(".tabs-item-js.active").data("tab");
        let numPage = url.split("page=").pop();

        $.ajax({
            url: url,
            data: {
                type: idTab,
            },
            success: function (responseHtml) {
                $(`#${idTab}`).html($(responseHtml).find(`#${idTab}`).html());
                // запоминаю номер последней открытой старницы у таба
                $(".tabs-item-js.active").attr("data-current-page", numPage);
            },
        });
    });
}